/* eslint-disable security/detect-object-injection */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useCallback, useEffect, useState
} from 'react';
import _ from 'lodash';
import { ToastProvider, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierPL-react/config/PremierPL-wizard-config.json5";
import metadata from './MedicalPractitionersPage.metadata.json5';
import styles from './MedicalPractitionersPage.module.scss';
import ProductCoverageSelection from "../../components/MedicalPractitioners/ProductCoverageSelection/ProductCoverageSelectionComponent"
import ClientDetailsComponent from "../../components/MedicalPractitioners/ClientDetails/ClientDetailsComponent"
import BusinessInformation from "../../components/MedicalPractitioners/BusinessInformation/BusinessInformationComponent"
import RevenueComponent from "../../components/MedicalPractitioners/Revenue/RevenueComponent"
import BusinessOperations1Component from '../../components/MedicalPractitioners/BusinessOperations1/BusinessOperations1Component';
import FacilitiesOperationsComponent from '../../components/MedicalPractitioners/FacilitiesOperations/FacilitiesOperationsComponent';
import SubcontractedservicesComponent from '../../components/MedicalPractitioners/Subcontractedservices/SubcontractedservicesComponent';
import RehabClinicsComponent from '../../components/MedicalPractitioners/RehabClinics/RehabClinicsComponent';
import RiskManagementComponent from '../../components/MedicalPractitioners/RiskManagement/RiskManagementComponent';
import PriorInsuranceHistoryComponent from '../../components/MedicalPractitioners/PriorInsuranceHistory/PriorInsuranceHistoryComponent';
import messages from './MedicalPractitionersPage.messages';

function MedicalPractitionersPage(props) {
    const {
        showAlert
    } = useModal();

    const { wizardData: submissionVM, updateWizardData, changeNextSteps, steps } = props;
    const translator = useTranslator();
    const { updateSubmission } = useUpdateSubmissionServices();
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'))
    const offeringCoverablePath = 'lobData.proLine.coverables.medicalParctitionarsCoverable.'
    const { lineName, jobTypes } = PremierConstants;
    
    const {
        onValidate,
        initialValidation
    } = useValidation('MedicalPractitionersPage');

    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {

            const { jobType } = submissionVM.value.baseData;

            const revenue = _.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.revenue')

            if(!_.isUndefined(revenue?.totRevClaA6) && revenue?.totRevClaA6 > 100) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totRevClaA6Msg),
                    autoClose: true
                });
                return false;
            } else if(!_.isUndefined(revenue?.totRevClaB7) && revenue?.totRevClaB7 > 100) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totRevClaB7Msg),
                    autoClose: true
                });
                return false;
            } else if(!_.isUndefined(revenue?.totRevClaC8) && revenue?.totRevClaC8 > 100) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totRevClaC8Msg),
                    autoClose: true
                });
                return false;
            } else if(!_.isUndefined(revenue?.totRevForAllCla9) && revenue?.totRevForAllCla9 > 100) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totRevForAllCla9Msg),
                    autoClose: true
                });
                return false;
            } else if(!_.isUndefined(revenue?.totRevForSerRelToAlt10) && revenue?.totRevForSerRelToAlt10 > 100) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totRevForSerRelToAlt10Msg),
                    autoClose: true
                });
                return false;
            } else if (!_.isUndefined(revenue?.totRevForSerRelToHea11) && revenue?.totRevForSerRelToHea11 > 100) {
                ToastProvider.toast({
                    type: 'error',
                    message: translator(messages.totRevForSerRelToHea11Msg),
                    autoClose: true
                });
                return false;
            }

            if (!_.isUndefined(submissionVM.value.lobData.proLine.coverables.medicalParctitionarsCoverable.productCoverageSelection.pro6)
                && submissionVM.value.lobData.proLine.coverables.medicalParctitionarsCoverable.productCoverageSelection.pro6) {
                if (_.filter(steps, (step) => step.id.includes('property')).length === 0) {
                    steps.splice(5, 0, propertySteps[0], propertySteps[1]);
                    changeNextSteps(steps.slice(4, 13))
                }
            } else {
                // eslint-disable-next-line no-lonely-if
                if (_.filter(steps, (step) => step.id.includes('property')).length !== 0) {
                    changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(4, 12))
                }
            }

            const productCode = _.get(submissionVM.value, 'baseData.productCode');

            const lobLineName = productCode ? lineName[productCode] : '';

            const response = await updateSubmission(lobLineName, 'MedicalPractitionersPage', submissionVM);

            submissionVM.value = response;

            return submissionVM;
        },
        [submissionVM, updateSubmission]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.proLine.coverables.medicalParctitionarsCoverable.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'MedicalPractitionersPage', subVMCopy);

            return submissionVM;
        },
        [submissionVM]
    );

    const overrideProps = {
        productCoverageSelection: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}productCoverageSelection`
        },
        clientDetailsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}clientDetails`
        },
        businessInformation: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}businessInformation`
        },
        revenueComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}revenue`
        },
        businessOperations1Component: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}businessOperations1`
        },
        facilitiesOperationsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}facilitiesOperations`
        },
        subcontractedservicesComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left"
                },
            },
            visible: !_.isUndefined(submissionVM.lobData.value.proLine.coverables.medicalParctitionarsCoverable.productCoverageSelection.doeTheAppSubAnyWorTo9) && submissionVM.lobData.value.proLine.coverables.medicalParctitionarsCoverable.productCoverageSelection.doeTheAppSubAnyWorTo9,
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}subcontractedservices`
        },
        rehabClinicsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: !_.isUndefined(submissionVM.lobData.value.proLine.coverables.medicalParctitionarsCoverable.productCoverageSelection.doeTheAppOffRehOrSub10) && submissionVM.lobData.value.proLine.coverables.medicalParctitionarsCoverable.productCoverageSelection.doeTheAppOffRehOrSub10,
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}rehabClinics`
        },
        riskManagementComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left"
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}riskManagement`
        },
        priorInsuranceHistoryComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${offeringCoverablePath}priorInsuranceHistory`
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productCoverageSelection: ProductCoverageSelection,
            clientDetailsComponent: ClientDetailsComponent,
            businessInformation: BusinessInformation,
            revenueComponent: RevenueComponent,
            businessOperations1Component: BusinessOperations1Component,
            facilitiesOperationsComponent: FacilitiesOperationsComponent,
            subcontractedservicesComponent: SubcontractedservicesComponent,
            rehabClinicsComponent: RehabClinicsComponent,
            riskManagementComponent: RiskManagementComponent,
            priorInsuranceHistoryComponent: PriorInsuranceHistoryComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isChecked = (value) => value !== undefined && value === true

    const isAnySubcontractedServicesChecked = () => {
        const isSubcontractorSelected = _.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.productCoverageSelection.doeTheAppSubAnyWorTo9');
        const isNursingChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.nur3'));
        const isCleaningChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.cle4'));
        const isMealPreparationChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.meaPre5'));
        const isSecurityChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.sec6'));
        const isWasteDisposalChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.wasDis7'));
        const isLaundryChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.lau8'));
        const isRoadMaintenanceChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.roaMai9'));
        const isLandscapingChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.lanLawCut10'));
        const isParkingChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.parGarOrLotOpe11'));
        const isSnowRemovalChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.snoRem12'));
        const isOtherChecked = isChecked(_.get(submissionVM.value, 'lobData.proLine.coverables.medicalParctitionarsCoverable.subcontractedservices.oth13'));

        return isSubcontractorSelected ? (isNursingChecked || isCleaningChecked || isMealPreparationChecked ||
            isSecurityChecked || isWasteDisposalChecked || isLaundryChecked || isRoadMaintenanceChecked ||
            isLandscapingChecked || isParkingChecked || isSnowRemovalChecked || isOtherChecked) : true
    }


    const isDisableNext = () => !submissionVM.lobData.proLine.coverables.medicalParctitionarsCoverable.aspects.subtreeValid
        || !isAnySubcontractedServicesChecked()

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

MedicalPractitionersPage.propTypes = wizardProps;
export default withRouter(MedicalPractitionersPage);
